import { NEWSDETAIL, ROOT } from "../../routes/routes_name"
import useNews from "./useNews"
import DOMPurify from "dompurify";
import LimitedText from "../../components/limited_text";
import { Link } from "react-router-dom";

const NewsPage = () => {
    const {
        data,
        links,
        isLoading,
        handleChangePage,
    } = useNews()
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>Berita</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">Berita</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section id="news" className="news section">
                    <div className="container">
                        <div className="row gy-3 " >
                            {
                                isLoading ? <div className="text-center">Loading...</div> :
                                    !data ? <div className="text-center">Data tidak ditemukan</div> :
                                        data.map((d, i) => {
                                            return (
                                                <div key={i} className="col-xl-3 col-lg-4 col-md-6">
                                                    <div className="card w-100">
                                                        <img src={d.image.thumbnail} className="card-img-top" alt="..." />
                                                        <div className="card-body">
                                                            <h5 className="card-title">{d.title}</h5>
                                                            <div className="card-text"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: DOMPurify.sanitize(LimitedText({ text: d.preview, limit: 50 })),
                                                                }}
                                                            />
                                                            <Link to={`${NEWSDETAIL}/${d.code}/${d.category.slug}`} className="read-more">Selengkapnya <i className="bi bi-arrow-right"></i> </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                            }

                        </div>
                        <div className="pagination-container w-100 my-4">
                            <nav aria-label="Page Navigation">
                                <ul className="pagination justify-content-center">
                                    {
                                        links.map((d, i) => (
                                            <li key={i} onClick={() => handleChangePage(d.url)} className={`page-item ${d.active === true ? "active" : ""} ${!d.url ? "disabled" : ""}`}><a className="page-link text-capitalize" href="#">{d.label.replace("pagination.", "")}</a></li>
                                        ))
                                    }
                                </ul>
                            </nav>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}
export default NewsPage